import * as yup from 'yup';

export const bookProfileTypeSchema = yup.object().shape({
  date: yup.date().required('date'),
  time: yup.string().required('time'),
  location: yup.string(),
  professionName: yup.string(),
  comments: yup.string()
});
